import { render, staticRenderFns } from "./BroadcastsCreate.vue?vue&type=template&id=a56a616e&"
import script from "./BroadcastsCreate.vue?vue&type=script&lang=ts&"
export * from "./BroadcastsCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports